// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__jA5Pb","navLink":"Navbar_navLink__6hnmd"};